// NPM imports
import moment from "moment";

// Internal Imports
import store from "../../store";
import { GRID } from "../../constants";
import { USER_ROLES } from "../../constants/roleList";

// Destructuring
const { GRID_PAGE_TYPE } = GRID;

export const parseColVisiblity = (obj, page) => {
  const reduxStore = store.getState();
  const { dealTableId } = reduxStore.QuotationStore;
  let columnDef = [];
  if (page === GRID_PAGE_TYPE.PRODUCTS) {
    columnDef = reduxStore.ProductsStore.columnDefs;
  } else if (page === GRID_PAGE_TYPE.PRICELIST) {
    columnDef = reduxStore.PricebookStore.columnDefs;
  } else if (page === GRID_PAGE_TYPE.DEALTABLE) {
    columnDef = reduxStore.DealTableStore.columnDefs[dealTableId];
  }

  function _getRolesBasedOnPage(roles) {
    // SalesRep will not see pricebook menu option & hence showing that option in manage column is not needed
    if (page === GRID_PAGE_TYPE.PRICELIST || page === GRID_PAGE_TYPE.PRODUCTS) {
      return roles.filter(role => role.name !== USER_ROLES.USER);
    }
    return roles;
  }

  const finalObj = [];
  const columns = columnDef.filter(item => item.hidden === undefined); // Filter columns which are not hidden
  const roles = _getRolesBasedOnPage(obj[0].Roles); // RBAC Roles
  const visibilityList = obj[1].Visibility; // Existing column visibility list
  columns.forEach(column => {
    // Column data goes here
    const items = {
      title: column.headerName,
      id: column.columnId,
      options: [],
    };
    // Add visible status of columns for all the roles
    roles.forEach(role => {
      const roleStatus = {
        id: role.id,
        name: role.name,
        visible:
          Object.keys(visibilityList).length > 0 &&
          Object.keys(visibilityList[role.id]).includes(column.columnId)
            ? visibilityList[role.id][column.columnId]
            : true, // If key exists then use the value else set the columns to visible true
      };
      items.options[role.id] = roleStatus;
    });
    finalObj.push(items);
  });

  const titles = [
    ...["Columns"],
    ...finalObj[0].options.map(item => item.name),
  ]; // Create column headers to display in the top

  return {
    data: finalObj,
    roles,
    titles,
  };
};

export const parseAppFlags = flags => {
  if (flags && flags.length > 0) {
    const payload = {};
    flags.forEach(data => {
      payload[data.flag] = data.value;
    });
    return payload;
  }
  return {};
};

export const generateMeteringUsage = data => {
  const metered = data[0];
  const payload = {};
  const ctaEvents = data[1];
  let ctaEventsUsage = {};
  const digitalTransaction = data[2];

  if (ctaEvents.length > 0) {
    ctaEventsUsage = ctaEvents.reduce(
      (obj, item) => Object.assign(obj, { [item.event]: item.count }),
      {},
    );
  }
  Object.keys(metered).forEach(key => {
    switch (key) {
      case "pdf_exports":
        payload.document_downloaded = {
          limit: metered[key].limit,
          usage: ctaEventsUsage.document_downloaded || 0,
        };
        delete payload.pdf_exports;
        break;
      case "send_for_acceptance":
        payload[key] = {
          limit: metered[key].limit,
          usage: ctaEventsUsage[key] || 0,
        };
        break;
      case "send_in_email":
        payload.send_to_someone = {
          limit: metered[key].limit,
          usage: ctaEventsUsage.send_to_someone || 0,
        };
        delete payload.send_in_email;
        break;
      case "snaplink":
        payload[key] = {
          limit: metered[key].limit,
          usage: ctaEventsUsage.generated_snaplink || 0,
        };
        break;
      case "permalink":
        payload[key] = {
          limit: metered[key].limit,
          usage: ctaEventsUsage.generated_magiclink || 0,
        };
        break;
      case "digital_transactions":
        payload[key] = {
          limit: metered[key].limit,
          usage: digitalTransaction.count || 0,
          isCounted: digitalTransaction.is_counted,
        };
        break;
      case "web_form_link":
        payload[key] = {
          limit: metered[key].limit,
          usage: ctaEventsUsage.generated_masterlink || 0,
        };
        break;
      default:
        payload[key] = metered[key];
        break;
    }
  });
  return payload;
};

export const getUsageEventsBasedOnPricingPlan = isFreePlan => {
  // Get Billing Info from redux
  const reduxStore = store.getState();
  const {
    billingInfo: {
      subscription: { next_billing_date: nxtBillingDate, plan_id: planId },
    },
  } = reduxStore.CommonStore;

  // Local Declarations
  const isMonthlyRenewal = planId.includes("monthly");
  const isAnnualRenewal = planId.includes("annual");
  const isEnterprise = planId.includes("ent");

  if (!isFreePlan && (isAnnualRenewal || isEnterprise)) {
    const date = new Date(nxtBillingDate * 1000); // Multiply with 1000, coz the value is in seconds & new Date expects in milliseconds
    const firstDay = new Date(
      date.getFullYear() - 1,
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ).toISOString();
    const lastDay = date.toISOString();
    return {
      firstDay,
      lastDay,
    };
  }

  if (!isFreePlan && isMonthlyRenewal) {
    const date = new Date(nxtBillingDate * 1000); // Multiply with 1000, coz the value is in seconds & new Date expects in milliseconds
    const firstDay = new Date(
      date.getFullYear(),
      date.getMonth() - 1,
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ).toISOString();
    const lastDay = date.toISOString();
    return {
      firstDay,
      lastDay,
    };
  }

  const date = new Date();
  const firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1))
    .startOf("day")
    .toISOString();
  const lastDay = moment(new Date(date.getFullYear(), date.getMonth() + 1, 0))
    .endOf("day")
    .toISOString();
  return {
    firstDay,
    lastDay,
  };
};
